"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _settingsWrapper = _interopRequireDefault(require("../../../../helpers/settingsWrapper"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = {
  renderCourseInOverlay: false // TODO: make this true by default without affecting existing Quests
};
exports.initialValues = initialValues;
var Settings = function Settings(_ref) {
  var _ref$questSettings$na = _ref.questSettings.navigationSettings,
    renderCourseInOverlay = _ref$questSettings$na.renderCourseInOverlay,
    modalHeaderImageUrl = _ref$questSettings$na.modalHeaderImageUrl,
    modalHeaderImageFileName = _ref$questSettings$na.modalHeaderImageFileName;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "renderCourseInOverlay",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Course in Modal over Description", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "If true, will initially render the course description as a landing page. The page will contain a button that, when clicked, will display the rest of the course material in a modal overlay. The overlay will NOT contain the course description tab."
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), renderCourseInOverlay && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].modalHeaderImagePicker
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "modalHeaderImageUrl",
    render: function render(_ref2) {
      var form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
        onChange: function onChange(_ref3) {
          var name = _ref3.name,
            url = _ref3.url;
          form.setFieldValue('modalHeaderImageUrl', url, true);
          form.setFieldValue('modalHeaderImageFileName', name, true);
        },
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default"
        }, modalHeaderImageUrl ? 'Change Modal Header Image' : 'Upload Modal Header Image')
      });
    }
  }), modalHeaderImageFileName && /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].fileName
  }, modalHeaderImageFileName)));
};
var _default = (0, _settingsWrapper["default"])({
  initialValues: initialValues
})(Settings);
exports["default"] = _default;